import api from './api'
import type { Company, PaginatedResponse } from '@/types'
import type {
  ApiResponse,
  BrandingSettingsResponse,
  CreateCompanyRequest,
  UpdateBrandingSettingsRequest,
  UpdateCompanyRequest,
  UpdateGoogleSettingsRequest,
  UpdateOpenAISettingsRequest,
} from '@/types/api'

const CompaniesService = {
  async getCurrent(): Promise<Company> {
    const response = await api.get<ApiResponse<Company>>('/api/v1/companies/current')
    return response.data.data
  },

  async getPublicBranding(host?: string | null): Promise<BrandingSettingsResponse> {
    const response = await api.get<ApiResponse<BrandingSettingsResponse>>('/api/v1/public/branding', {
      params: host ? { host } : undefined,
    })
    return response.data.data
  },

  async getCurrentBranding(): Promise<BrandingSettingsResponse> {
    const response = await api.get<ApiResponse<BrandingSettingsResponse>>('/api/v1/companies/current/branding')
    return response.data.data
  },

  async getAll(): Promise<Company[]> {
    const response = await api.get<PaginatedResponse<Company>>('/api/v1/companies')
    return response.data.data
  },

  async create(data: CreateCompanyRequest): Promise<Company> {
    const response = await api.post<ApiResponse<Company>>('/api/v1/companies', data)
    return response.data.data
  },

  async update(companyId: string, data: UpdateCompanyRequest): Promise<Company> {
    const response = await api.put<ApiResponse<Company>>(`/api/v1/companies/${companyId}`, data)
    return response.data.data
  },

  async updateBranding(data: UpdateBrandingSettingsRequest): Promise<Company> {
    const response = await api.put<ApiResponse<Company>>('/api/v1/companies/current/settings/branding', data)
    return response.data.data
  },

  async updateOpenAISettings(data: UpdateOpenAISettingsRequest): Promise<Company> {
    const response = await api.put<ApiResponse<Company>>('/api/v1/companies/current/settings/openai', data)
    return response.data.data
  },

  async updateGoogleSettings(data: UpdateGoogleSettingsRequest): Promise<Company> {
    const response = await api.put<ApiResponse<Company>>('/api/v1/companies/current/settings/google', data)
    return response.data.data
  },
}

export default CompaniesService
